<template>
  <div>
    <div
      class="about-banner"
      :style="{
        backgroundImage: `url(${$store.state.OPTIONS._app_background})`,
      }"
    >
      <v-container style="margin-top: 100px">
        <h1>{{ $t('about.title') + $store.state.OPTIONS._app_title }}</h1>
        <span>{{$t('about.subtitle')}}</span>
      </v-container>
    </div>
    <v-container>
      <v-row>
        <v-col cols="7">
          <!--L-->
          <v-row class="">
            <v-col cols="12">
              <v-card class="mt-n3">
                <v-card-title class="grey darken-2 white--text">
                  <v-icon class="mr-2 white--text">import_contacts</v-icon>README.MD
                </v-card-title>
                <v-card-text>{{ $tc('about.readme', 1) + (new Date().getFullYear() - 2016) + $tc('about.readme', 2)}}</v-card-text>
              </v-card>
            </v-col>
            <v-col cols="12">
              <h3>{{$t('about.donate_title')}}</h3>
              <v-row>
                <v-col cols="7">
                  <v-card>
                    <v-card-text>
                      <i18n path="about.donate_text" tag="span">
                        <br place="br"><strong place="strong1">{{$tc('about.donate_strong', 0)}}</strong><strong place="strong2">{{$tc('about.donate_strong', 1)}}</strong><strong place="strong3">{{$tc('about.donate_strong', 2)}}</strong><br place="br">
                      </i18n>
                    </v-card-text>
                  </v-card>
                </v-col>
                <!-- <v-col cols="4">
                  <v-card href="https://afdian.net/@makjust" target="_blank">
                    <v-card-title>
                      <span>爱发电</span>
                    </v-card-title>
                    <v-card-text>
                      <v-skeleton-loader type="image"
                        ><v-img
                          src="https://cdn.jsdelivr.net/gh/MAKjustProject/static@master/img/www.makjust.com/afdian.xF8I6dl2peXJrTw.png"
                          max-width="100%"
                        ></v-img>
                      </v-skeleton-loader>
                    </v-card-text>
                  </v-card>
                </v-col>
                <v-col cols="4">
                  <v-card>
                    <v-card-title>
                      <span>微信赞赏码</span>
                    </v-card-title>
                    <v-card-text>
                      <v-img
                        src="https://cdn.jsdelivr.net/gh/MAKjustProject/static@master/img/www.makjust.com/wechat.QdgjpSWXYJlwmPD.png"
                        max-width="100%"
                      ></v-img>
                    </v-card-text>
                  </v-card>
                </v-col> -->
                <v-col cols="5">
                  <h4>{{$t('about.donate_list')}}</h4>
                  <v-simple-table>
                    <template v-slot:default>
                      <thead>
                        <tr>
                          <th>{{$tc('about.donate_tHead',0)}}</th>
                          <th>{{$tc('about.donate_tHead',1)}}</th>
                          <th>{{$tc('about.donate_tHead',2)}}</th>
                        </tr>
                      </thead>
                      <tbody v-if="typeof desserts === 'object'">
                        <tr v-for="item in desserts" :key="item.name">
                          <td>{{ item.name }}</td>
                          <td>{{ $tc('about.donate_channels', item.channel) }}</td>
                          <td>{{ `${item.num} CNY` }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                  <v-alert v-if="desserts === 0" color="info" dark>
                    <v-progress-circular
                      indeterminate
                      color="white"
                      style="margin-right: 10px"
                    ></v-progress-circular>{{$t('about.doante_loading')}}</v-alert>
                  <v-alert v-if="desserts === 1" type="warning">
                    {{$t('about.donate_error')}}
                  </v-alert>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="5">
          <!--R, Update-->
          <v-card loading>
            <v-card-title class="grey darken-2 white--text">
              <v-icon class="mr-2 white--text">update</v-icon>UPDATE.MD<img
                class="ml-4"
                :src="`https://img.shields.io/badge/MAKjust%20Web-v${this.$t(
                  'all.version'
                ).replace(/\-(\w+)/, '($1)')}-blue?style=flat&logo=github`"/>
            </v-card-title>
            <v-timeline dense align-top>
              <v-timeline-item
                v-for="(year, i) in years"
                :key="i"
                :color="year.color"
                small
                fill-dot
              >
                <template v-slot:opposite> </template>
                <span class="text-subtitle-1">v{{ year.title }}</span>
                <v-card-text v-if="year.content">{{ year.content }}</v-card-text>
              </v-timeline-item>
            </v-timeline>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import marked from "marked";
import mjp from "@/plugins/makjust";

var rendererMD = new marked.Renderer();
marked.setOptions({
  renderer: rendererMD,
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false,
});
export default {
  name: "ABOUT",
  data() {
    return {
      desserts: 0,
      channelBy: ["爱发电", "微信", "支付宝", "QQ"],
      years: [
        {
          color: "cyan",
          year: "2019",
          title: "进步",
          content:
            "新技术下诞生了一个稳定（大概）新官网，便开始重构自研旧启动器“MAKjust Luncher”为“NyanClient(Luncher)”；并启动“MAKjustID”、“WorkerProject”等项目。",
        },
        {
          color: "green",
          year: "2018",
          title: "起步",
          content:
            "（2017？鸽了）将旧官网进行完全重构，技术栈由jQurey、php转为Vue、Node(+Vert.x)。",
        },
        {
          color: "pink",
          year: "2016",
          title: "重来",
          content:
            "在2016年6月，由管理员CrazyDouzi牵头，组织并启动了“MAKjust”PC服务器，顺便开发了一个十分难用的启动器（手动狗头）。",
        },
        {
          color: "amber",
          year: "2015",
          title: "寂静",
          content: "学业，兴趣，未来，在多方面原因影响下关闭了服务器。",
        },
        {
          color: "orange",
          year: "2014",
          title: "诞生",
          content: "MAKjust前身————一个岌岌无名的PE服务器群组在兴趣中诞生了",
        },
      ],
    };
  },
  computed: {},
  mounted() {
    mjp.getDonors().then((d) => {
      let donors = [];
      for (let donor of d.data.results) {
        donors.push({
          name: donor.by,
          channel: donor.channel,
          num: donor.num,
        });
      }
      this.desserts = donors;
    });
  },
  created() {
    // var self = this;
    // axios
    //   .get("https://api.makjust.com/bin/update/")
    //   .then(function (res) {
    //     self.webUpdate = marked(res.data || "NULL", { sanitize: true });
    //   })
    //   .catch(function (err) {
    //     err;
    //     self.webUpdate = "获取失败！";
    //   });
    // axios
    //   .get("https://api.makjust.com/bin/luncher/")
    //   .then(function (res) {
    //     self.clientUpdate = marked(res.data || "NULL", { sanitize: true });
    //   })
    //   .catch(function (err) {
    //     err;
    //     self.clientUpdate = "获取失败！";
    //   });
  },
};
</script>

<style>
/* @import url(https://cdn.jsdelivr.net/npm/github-markdown-css@4.0.0/github-markdown.min.css); */
.markdown-body pre code {
  color: rgba(0, 0, 0, 0.6);
  box-shadow: unset;
  font-weight: 400;
}
.markdown-body pre code:before {
  content: "" !important;
}
.about-banner {
  position: relative;
  height: 46vh;
  width: 100%;
  color: white;
  margin-top: -110px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  background-color: #cccccc;
  background-position: top;
  background-size: cover;
}
.about-banner > div h1 {
  font-weight: 100;
  font-size: 3rem;
}
</style>